const envConfig = window.config.env

export const { envModes, envMode } = envConfig

export default envConfig

export const MESSAGE_VIEW_COUNT_IS_ENABLED =
  import.meta.env.VITE_DISABLE_MESSAGE_VIEW_COUNT !== 'true'

export const FORCE_INSTALL_TWA_ENABLED =
  import.meta.env.VITE_INSTALL_TWA_MODE === 'FORCE'

export const RECOMMEND_INSTALL_TWA_ENABLED =
  import.meta.env.VITE_INSTALL_TWA_MODE === 'RECOMMEND'

export const WORKSPACE_ENABLED =
  import.meta.env.VITE_WORKSPACE_ENABLED === 'true'

export const SUPPORT_ASSISTANT_ENABLED =
  import.meta.env.VITE_SUPPORT_ASSISTANT_ENABLED === 'true'

export const VALIDATE_MESSAGE_FILE_SIZE_ENABLED =
  import.meta.env.VITE_VALIDATE_MESSAGE_FILE_SIZE === 'true'

export const MEDIA_SERVER_API_URL = import.meta.env
  .VITE_MEDIA_SERVER_API_URL as string
export const MEDIA_PROXY_API_URL = import.meta.env
  .VITE_MEDIA_PROXY_API_URL as string
export const CHECK_VPN_HOST = import.meta.env.VITE_CHECK_VPN_HOST as string
export const TOUR_API_URL = import.meta.env.VITE_TOUR_API_URL as string
